import type { SmsEventsFilters } from '@models/smsEvent'
import { keyToUrl } from '@tools/common'
import { omit } from 'lodash'

export const smsEventsKeys = {
  root: ['smsEvents'] as const,
  smsEventsAdmin: (filters?: SmsEventsFilters) =>
    [
      ...smsEventsKeys.root,
      omit(filters, ['page', 'limit']),
      { page: filters?.page, limit: filters?.limit },
    ] as const,
}

export const smsEventsUrls = {
  smsEventsAdmin: keyToUrl(smsEventsKeys.smsEventsAdmin()),
}
